import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { Dossier } from '@sc/data-access-models';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'sc-sinister-comment',
  styleUrls: ['./sinister-comment.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <h2>{{ 'SinisterDataForm.commentTitle' | translate }}</h2>
    <aside class="_comment">
      {{ dossier.claim.sinisterComment }}
      <br
        *ngIf="
          !!dossier?.claim?.sinisterComment && !!dossier?.fitterInfo?.message
        "
      />
      {{ dossier?.fitterInfo?.message }}
    </aside>
  `,
  imports: [NgIf, TranslateModule],
})
export class SinisterCommentComponent {
  @Input() dossier: Dossier;
}
